import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";

import {
  deleteResource,
  deleteResourceById,
  selectResourceForDeletion,
  selectState,
  setDeleteResourceModalOpen,
} from "../main.slice";

const DeleteResourceModal = () => {
  const { deleteResourceModalOpen } = useSelector(selectState);
  const resource = useSelector(selectResourceForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteResourceModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      await dispatch(deleteResource(resource.resourceId));
      dispatch(deleteResourceById({ resourceId: resource.resourceId }));
      toast.success("Uspesno obrisan.");
      close();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deleteResourceModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje resursa"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeći resurs:
        <br />
        <br />
        <b>{resource?.name} ?</b>
      </p>
    </Modal>
  );
};

export default DeleteResourceModal;
